<template>
  <div>
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="hours-history"
      identifier="hours_history_table"
      :floatActions="floatActions"
      :rowActions="rowActions"
      @error="error = $event"
      :canExpand="(item) => false"
      :show-select="false"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateExpandedProvider(item)"
      :sortBy="'CalendarYear'"
      :sortDescending="true"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-dialog
      v-model="dialogs.showForm"
      scrollable
      max-width="1000px"
      persistent
    >
      <template v-if="planIdentity.HasEligibilityBank">
        <member-self-payments-form-eligibility-bank
          v-if="dialogs.showForm"
          :memberIdentityId="memberId"
          :item="selectedItem"
          @close="dialogs.showForm = false"
          @save="onSave"
          :eligibilityBankId="eligibilityBankId"
        />
      </template>
      <template v-else>
        <member-self-payments-form
          v-if="dialogs.showForm"
          :memberIdentityId="memberId"
          :item="selectedItem"
          @close="dialogs.showForm = false"
          @save="onSave"
        />
      </template>
    </v-dialog>
    <v-dialog v-model="addMany" scrollable max-width="1200px" persistent>
      <template v-if="planIdentity.HasEligibilityBank">
        <member-self-payments-add-many-eligibility-bank
          v-if="addMany"
          :memberIdentityId="memberId"
          @close="addMany = false"
          @save="
            addMany = false;
            $refs.table.getDataAsync();
            $emit('reload');
          "
          :eligibilityBankId="eligibilityBankId"
        />
      </template>
      <template v-else>
        <member-self-payments-add-many
          v-if="addMany"
          :memberIdentityId="memberId"
          @close="addMany = false"
          @save="
            addMany = false;
            $refs.table.getDataAsync();
            $emit('reload');
          "
        />
      </template>
    </v-dialog>
    <v-dialog v-model="showDelete" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("components.hoursbulktable.delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("components.hoursbulktable.delete_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showDelete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="deleteItem" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/SelfPayments";
import MemberSelfPaymentsFormEligibilityBank from "@/components/MemberSelfPaymentsFormEligibilityBank";
import MemberSelfPaymentsAddManyEligibilityBank from "@/components/MemberSelfPaymentsAddManyEligibilityBank";
import MemberSelfPaymentsForm from "@/components/MemberSelfPaymentsForm";
import MemberSelfPaymentsAddMany from "@/components/MemberSelfPaymentsAddMany";
import ErrorHandler from "@/components/ErrorHandler";
import { locker } from "../mixins/locker";

export default {
  props: {
    coverageEffectiveDate: String,
    memberId: String,
    employerId: String,
    eligibilityBankId: String,
    showActive: {
      default: true,
    },
  },
  mixins: [locker],
  components: {
    MemberSelfPaymentsFormEligibilityBank,
    MemberSelfPaymentsAddManyEligibilityBank,
    ErrorHandler,
    MemberSelfPaymentsForm,
    MemberSelfPaymentsAddMany,
  },
  data() {
    return {
      addMany: false,
      loading: false,
      valid: true,
      reason: null,
      saving: false,
      showDelete: false,
      provider: null,
      rowActions: [
        {
          title: "globals.edit",
          name: "edit",
          icon: "edit",
          handler: async (item) => {
            try {
              this.loading = true;
              this.selectedItem = (
                await this.lock(
                  this.getMemberSelfPayments,
                  {
                    planIdentityId: this.selectedPlan.Id,
                    memberIdentityId: this.memberId,
                    id: item.Id,
                    dialogs: this.dialogs,
                    dialog: "showForm",
                  },
                  () => {
                    this.dialogs.showForm = false;
                  }
                )
              ).value[0];
              console.log("$$$$$$$$$$$$$$$$$$$$$$", this.selectedItem);
              this.dialogs.showForm = true;
            } catch (error) {
              this.error = error;
            } finally {
              this.loading = false;
            }
          },
          // visible: ()=>!this.planIdentity.HasEligibilityBank
        },
        {
          title: "globals.delete",
          name: "delete",
          icon: "delete",
          handler: (item) => {
            this.selectedItem = item;
            this.showDelete = true;
          },
          // visible: ()=>!this.planIdentity.HasEligibilityBank
        },
      ],
      floatActions: [],
      dialogs: {
        showForm: false,
      },
      selectedItem: null,
      error: null,
    };
  },
  methods: {
    ...mapActions("plansMembers", [
      "deleteMemberSelfPayments",
      "getMemberSelfPayments",
    ]),
    async loadData() {
      console.log("cov eff date", this.coverageEffectiveDate);
      if (this.planIdentity.HasEligibilityBank) {
        if (
          this.coverageEffectiveDate !== null &&
          this.coverageEffectiveDate !== undefined
        ) {
          this.floatActions = [
            {
              text: "globals.add_new",
              color: this.$vuetify.theme.themes.light.success,
              name: "add",
              icon: "add",
              handler: () => {
                this.selectedItem = {
                  MemberIdentityId: this.memberId,
                  PlanIdentityId: this.selectedPlan.Id,
                  PaymentDate: null,
                  Amount: "",
                  Deposited: false,
                  Role: "Admin",
                  User: this.user,
                  CalendarMonth: null,
                  CalendarYear: null,
                };
                this.dialogs.showForm = true;
              },
            },
          ];
        }
      } else {
        this.floatActions = [
          {
            text: "globals.add_new",
            color: this.$vuetify.theme.themes.light.success,
            name: "add",
            icon: "add",
            handler: () => {
              this.selectedItem = {
                MemberIdentityId: this.memberId,
                PlanIdentityId: this.selectedPlan.Id,
                PaymentDate: null,
                Amount: "",
                Deposited: false,
                Role: "Admin",
                User: this.user,
                CalendarMonth: null,
                CalendarYear: null,
              };
              this.dialogs.showForm = true;
            },
          },
          {
            text: "components.memberselfpaymentstable.add_many",
            color: this.$vuetify.theme.themes.light.success,
            name: "addMany",
            icon: "add",
            handler: () => {
              this.addMany = true;
            },
          },
        ];
      }

      let headers = getHeaders(this.options.Enums);
      this.provider = null;
      if (this.memberId) {
        const url = `/plans/${this.selectedPlan.Id}/members/${this.memberId}/self-payments`;
        this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      }
    },

    async deleteItem() {
      this.saving = true;
      this.error = null;
      try {
        await this.deleteMemberSelfPayments({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberId,
          id: this.selectedItem.Id,
        });
        this.$refs.table.getDataAsync();
        this.$emit("reload");
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
        this.showDelete = false;
      }
    },
    generateExpandedProvider(item) {
      const headers = getHeaders(this.options.Enums);
      const url = `/plans/${this.selectedPlan.Id}/members/${this.memberId}/self-payments/by-payment-id/${item.PaymentId}`;
      const p = new ODataProvider(this.$axiosHttp, url, headers);
      return p;
    },
    onSave() {
      this.dialogs.showForm = false;
      this.$refs.table.getDataAsync();
      this.$emit("reload");
    },
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["role", "user"]),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
  },
  watch: {
    memberId: {
      immediate: true,
      handler: async function () {
        await this.loadData();
      },
    },
    employerId: {
      immediate: true,
      handler: async function () {
        await this.loadData();
      },
    },
  },
  // mounted() {
  //   console.log("id", this.memberId);
  //   console.log("employer", this.employerId);
  // },
};
</script>
